import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SignalEntityQuery} from '../../state/signal-entity.store';
import {MiniQuestionState, MiniQuestionStore} from './mini-question.store';
import {Question} from '../../models/underwriter.model';

@Injectable({
    providedIn: 'root'
})
export class MiniQuestionQuery extends SignalEntityQuery<Question, MiniQuestionState>{
    constructor(protected store: MiniQuestionStore) {
        super(store);
    }

    getById(id: any): Observable<any> {
        return this.selectAll({
          filterBy: [
            entity => entity.cent_aq_question_id === id
          ]
        });
      }

}
